import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDelete = props => /*#__PURE__*/_jsx("svg", {
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M5.3 19.8c0 1.2 1 2.2 2.2 2.2h8.9c1.2 0 2.2-1 2.2-2.2V6.4H5.3v13.4zM19.8 3.1h-3.9L14.8 2H9.2L8.1 3.1H4.2v2.2h15.6V3.1z"
  })
});
export default SvgDelete;